import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.SearchResultsDocumentTemplate,
): React.JSX.Element => {
    const {
        search_action_url,
        search_query,
        suggested_query,
        results,
        has_previous,
        previous_page_number,
        has_next,
        next_page_number,
        num_pages,
        pagination_label,
        label_search,
        label_no_results,
        label_please_type,
        label_first,
        label_previous,
        label_next,
        label_last,
        ga_events,
    } = props;

    let responses: React.ReactNode;
    if (results.length > 0) {
        responses = results.map((result, i) => (
            <li
                key={i}
                className="search-result"
                data-score={result.data_score}
            >
                <div className="search-result__image">
                    {result.image_url && (
                        <a href={result.url}>
                            <img
                                src={result.image_url}
                                alt={result.image_caption}
                                title={result.image_caption}
                                loading="lazy"
                                decoding="async"
                            />
                        </a>
                    )}
                </div>
                <div className="search-result__info">
                    <span className="search-result__info__type">
                        {result.type_label}
                    </span>
                    <h4 className="search-result__info__name">
                        <a href={result.url}>{result.title}</a>
                    </h4>
                    <div
                        className="search-result__info__description"
                        dangerouslySetInnerHTML={{
                            __html: result.description_html,
                        }}
                    />
                </div>
            </li>
        ));
    } else if (search_query) {
        responses = (
            <li className="search-result--default">{label_no_results}</li>
        );
    } else {
        responses = (
            <li className="search-result--default">{label_please_type}</li>
        );
    }

    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width" style={{ paddingTop: "150px" }}>
                <div className="search-results">
                    <div className="search-results__search-bar">
                        <form
                            className="search-results__search-form"
                            action={search_action_url}
                            method="get"
                        >
                            <input
                                type="text"
                                name="query"
                                defaultValue={search_query}
                                className="search-results__search-input"
                                placeholder={label_search}
                            />
                            <span>
                                <svg
                                    className="search-results__clear-icon"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlSpace="preserve"
                                    viewBox="52.9 54.2 43 43.6"
                                >
                                    <path
                                        fill="#999"
                                        d="M54.3 97.4c-.2 0-.7 0-1-.2-.5-.5-.5-1.2 0-1.8l40.5-40.5c.5-.5 1.2-.5 1.8 0 .5.5.5 1.2 0 1.8L55 97.1c-.2.3-.5.3-.7.3"
                                    />
                                    <path
                                        fill="#999"
                                        d="M94.8 97.4c-.2 0-.8 0-1-.2L53.2 56.6c-.5-.5-.5-1.2 0-1.8.5-.5 1.2-.5 1.8 0l40.5 40.5c.5.5.5 1.2 0 1.8 0 .3-.5.3-.7.3"
                                    />
                                </svg>
                            </span>
                        </form>
                        {suggested_query && (
                            <div className="search-results__suggested-query">
                                <p>
                                    Showing results for <em>{search_query}</em>
                                </p>
                                <p
                                    data-suggestion-score={
                                        suggested_query.score
                                    }
                                >
                                    Did you mean:{" "}
                                    <a href={suggested_query.href}>
                                        <em>{suggested_query.query_text}</em>
                                    </a>
                                </p>
                            </div>
                        )}
                    </div>
                    <ul className="search-results__responses">{responses}</ul>
                    <div className="search-results__pagination">
                        <div className="search-results__pagination__links search-results__pagination__links--previous">
                            {has_previous && (
                                <>
                                    <a
                                        href={`?query=${encodeURIComponent(search_query)}&page=1`}
                                    >
                                        {"«"} {label_first}
                                    </a>
                                    {" | "}
                                    <a
                                        href={`?query=${encodeURIComponent(search_query)}&page=${previous_page_number}`}
                                    >
                                        {label_previous}
                                    </a>
                                </>
                            )}
                        </div>
                        <div className="search-results__pagination__links search-results__pagination__current">
                            {pagination_label}
                        </div>
                        <div className="search-results__pagination__links search-results__pagination__links--next">
                            {has_next && (
                                <>
                                    <a
                                        href={`?query=${encodeURIComponent(search_query)}&page=${next_page_number}`}
                                    >
                                        {label_next}
                                    </a>
                                    {" | "}
                                    <a
                                        href={`?query=${encodeURIComponent(search_query)}&page=${num_pages}`}
                                    >
                                        {label_last} {"»"}
                                    </a>
                                </>
                            )}
                        </div>
                    </div>
                    <DataLayerPush events={ga_events} />
                </div>
            </div>
        </PageSkeleton>
    );
};
